import React,{Component} from 'react';
import {withRouter} from "react-router";
import "../../assets/css/common/search.css";
import {Modal} from 'antd-mobile';
import Ajax from "../../assets/js/libs/axios.js";		//数据请求
import {connect} from 'react-redux';
//import hkActions from '../../rAction';
import { Toast} from 'antd-mobile';


class SearchComponent extends Component{
    constructor(props){
        super(props);
        this.state = {
       		bHistroy: true,
       		hotwords: [],
       		keywords: "",
       		defaultValue: ""
        }
		this.Arrkeywords = props.state.HK.keywords;
    }
    componentDidMount(){
        if (this.props.state.HK.keywords.length>0){
            this.setState({bHistory:true})
        } else{
            this.setState({bHistory:false})
        }
    }
    componentWillReceiveProps(){
    	//console.log(this.props.kwords)
    	this.setState({
    		defaultValue: this.props.kwords
    	})
    }
    addHistoryKeywords(){
    	//console.log(this.state.keywords,this.Arrkeywords)
    	let keywords = this.state.kwords || this.state.keywords;
	  	if(this.refs['keywords'].value !== ''){
			for(let i=0;i<this.Arrkeywords.length;i++){
    			if(this.Arrkeywords[i] === keywords){
    				this.Arrkeywords.splice(i--,1);
    			}
    		}
			this.Arrkeywords.unshift(keywords);
			localStorage['hkArr'] = JSON.stringify( this.Arrkeywords );
			//this.props.dispatch(hkActions.hk.AddHistory(this.Arrkeywords));
			this.setState({
	    		bHistroy: true
	    	});
	    	this.goSearch('/searcgDetail?keywords='+keywords, keywords)
  		}else{
  			Toast.info('请正确输入内容！', 2);
  		}
    }
    goSearch(url, keywords){
    	//console.log(1,this.props,url, keywords)
    	localStorage['searchKeywords'] = keywords;
    	if(this.props.isLocal === '1'){
    		//本页查询
    		this.props.isLocalSearch(keywords);
    	}else{
    		this.props.history.push(url);
    	}
    }
    showAlert () {
	  const alertInstance = Modal.alert('', '是否确定删除最近搜索?', [
	    { text: '退出', onPress: () => console.log('退出'), style: 'default' },
	    { text: '确定', onPress: () => {
	    	this.setState({
	    		bHistroy: false
	    	});
	    	localStorage.removeItem('hkArr');
	    	//this.props.dispatch({type:"addHK",keywords:[]})
	    	//this.props.dispatch(hkActions.hk.AddHistory([]));
	    	this.Arrkeywords = [];
	    }},
	  ]);
	  setTimeout(() => {
	    // 可以调用close方法以在外部close
	    //console.log('auto close');
	    alertInstance.close();
	  }, 500000);
	};
	componentWillUnmount(){
		this.setState = (state, callback)=>{
			return;
		}
	}
    render(){
        return(
            <div className={'page page-search'} style={this.props.searchStyle}>
                <div className={'search-header3'}>
                    <div className={'search-wrap'}>
                    	<button type="button" className={'search-btn'} onClick={this.addHistoryKeywords.bind(this)}></button>
                        <div className={'search-input-wrap'}>
                        	<form action='' onSubmit={this.addHistoryKeywords.bind(this)}>
                        		<input type="search" className={'search'} placeholder="搜索" ref='keywords' defaultValue={this.state.defaultValue} onChange={(e)=>{this.state.keywords=e.target.value}} />
						    </form>
                        </div>
                    </div>
                    <div className={'close'} onClick={this.props.display.bind(this,{display:"none"})}>取消</div>
                </div>
                <div className={this.state.bHistroy?'search-main2':'search-main2 hide'}>
                    <div className={'search-title-wrap'}>
                        <div className={'search-title'}>最近搜索</div>
                        <div className={'bin'} onClick={this.showAlert.bind(this)}></div>
                    </div>
                    <div className={'search-keywords-wrap'}>
                        {
                        	this.props.state.HK.keywords.map((item,index)=>{
                        		return(
                        			<div key={index} className={'keywords'} onClick={this.goSearch.bind(this,'/searcgDetail?keywords='+item,item)}>
                        				
                        				{item}
                        			</div>
                        		)
                        	})
                        }    
                    </div>
                </div>
                <div className={'search-main2'}>
                    <div className={'search-title-wrap'}>
                    {
//                  	<div className={'search-title'}>热门搜索</div>
                    }
                    </div>
                    <div className={'search-keywords-wrap'}>
                        {
                        	this.state.hotwords.map((item,index)=>{
                        		return(
                        			<div key={index} className={'keywords'} onClick={this.goSearch.bind(this,'/searcgDetail?keywords='+item.title,item.title)}>
                        				<img src={require('../../assets/images/video/hot.png')} />
                        				{item.title}
                        			</div>
                        		)
                        	})
                        }      
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state)=>{
    return{
        state:state
    }
})(withRouter(SearchComponent))
//export default connect(state => state)(SearchComponent);